"use client"

import { useCookies } from "next-client-cookies"
import LoginButton from "@/components/ui/LoginButton"
import SignupButton from "@/components/ui/SignupButton"

export default function HeaderAuthButtons({
  loginText,
  signupText,
  forceModal,
}: {
  loginText: string
  signupText: string
  forceModal?: boolean
}) {
  const cookies = useCookies()
  const token = cookies.get("token")

  if (token) {
    return (
      <li className="ml-6">
        <a
          className="btn-sm text-slate-300 hover:text-white transition duration-150 ease-in-out w-full group [background:linear-gradient(theme(colors.slate.900),_theme(colors.slate.900))_padding-box,_conic-gradient(theme(colors.slate.400),_theme(colors.slate.700)_25%,_theme(colors.slate.700)_75%,_theme(colors.slate.400)_100%)_border-box] relative before:absolute before:inset-0 before:bg-slate-800/30 before:rounded-full before:pointer-events-none"
          href="/app"
        >
          <span className="relative inline-flex items-center">
            Dashboard{" "}
            <span className="tracking-normal text-purple-500 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1">
              -&gt;
            </span>
          </span>
        </a>
      </li>
    )
  }

  return (
    <>
      <li>
        <LoginButton text={loginText} forceModal={forceModal} />
      </li>
      <li className="ml-6">
        <SignupButton text={signupText} forceModal={forceModal} />
      </li>
    </>
  )
}
